<template>
    <div class="classifyList">
        <!-- 头部 -->
        <div class="home">
            <div class="top">
                <h2>课程中心</h2>
            </div>
            <div class="mindCont" v-if="isShowContent">
                <div class="classify_nav">
                    <p :class="allActive?'router-link-active':''" @click="getDataFn('all')">全部</p>
                    <p v-for="(item,index) in navList" :key="index" :class="allActive?'':(active==index?'router-link-active':'')" @click="getDataFn('part',item.ID,index)">{{item.Name}}{{'('+item.TotalNum+')'}}</p>
                </div>
            </div>
        </div>
        <div v-if="isShowContent">
			<!-- 表头 -->
			<div class="topTitle">
			    <div class="left-t">
			        <h5>共有{{totalPage}}门课程</h5>
			        <p class="videoNumBox">{{videoNum}}个视频</p>
			    </div>
			    <div class="hns">
			        <span :class="light==2?'light':''" @click="changeSort(2)">时间</span>
			        <span :class="light==0?'light':''" @click="changeSort(0)">热门</span>
			        <span :class="light==1?'light':''" @click="changeSort(1)">名称</span>
			    </div>
			</div>
			<!-- 列表 -->
			<ul class="listWrap">
			    <li v-for="(item,index) in courseList" :key="index">
			        <router-link :to="{path:'/classDetial', query:{courseId:item.ID}}" @click.native="saveID(item.ID)">
			            <div class="picBox">
			                <img :src="item.ImgPath" />
			                <p><span>{{item.Score}}</span><span>学分</span></p>
			            </div>
			            <div class="infoWrap">
			                <p class="category"><span>{{item.Keywords}}</span></p>
			                <h2>{{item.Title}}</h2>
			                <div class="info">
			                    <p>时长：<span>{{item.Duration}}</span></p>
			                    <p>播放：<span>{{item.Hits}}</span></p>
			                    <p>日期：<span>{{item.PubDate | formatData}}</span></p>
			                </div>
			            </div>
			            <div class="head-zan">
			                <p class="head"><img src="../../assets/img/speaker.jpg" /><span>{{item.LectureName}}</span></p>
							<p class="department" v-if="item.Memo != '无' && item.Memo != ''"><img src="../../assets/img/class_icon.svg" ><span>{{item.Memo}}</span></p>
			                <div class="zan"><p><img src="../../assets/img/zanBefore.svg" /></p><span>{{item.Tags}}</span></div>
			            </div>
			        </router-link>
			    </li>
			</ul>
			<!-- 分页器 -->
			<div class="page"><Pagination :total='totalPage' :page="page" :pageSize = 'pagesize' @currentPage="currentPage"></Pagination></div>
			<!-- 移动端 -->
			<p class="moreCourse" v-if="isShowMore" @click="getMore">更多课程</p>
		</div>
        <!-- IE浏览器内容显示 -->
		<div style="width: 900px;margin: 100px auto;color: #19191A;" class="ieContWrap" v-else>
			<h2 style="text-align: center;font-size: 25px;margin-bottom: 30px;">关于OA教培门户的兼容性使用通知</h2>
			<p style="font-size: 16px;font-size: 16px;line-height: 30px;">各基层单位、各部门：</p>
			<p style="text-indent: 30px;font-size: 16px;line-height: 30px;">由于微软早些年停止了IE浏览器的升级更新，导致一些新的web技术在IE浏览器上并不支持。随着微软的停止更新服务，IE浏览器将会变得越来越慢，且非常不安全，所以希望别再继续使用。</p>
			<p style="text-indent: 30px;font-size: 16px;line-height: 30px;">OA教培门户是基于这些新web技术开发的教育培训平台，为给您的线上学习提供最好的效果，公司教培中心及标信小组建议您使用基于谷歌架构的浏览器如：chrome浏览器（google浏览器），或edge浏览器、firefox浏览器、qq浏览器、opera浏览器。</p>
			<p style="text-indent: 30px;font-size: 16px;line-height: 30px;">注：此问题仅在PC网页端的云课堂上偶有发生，钉钉端（手机、平板、电脑）不受影响。</p>
			<p style="text-indent: 30px;font-size: 16px;line-height: 30px;">附：Chrome浏览器下载地址：<a href="https://www.google.cn/chrome/" target="_blank">www.google.cn/chrome/</a></p>
			<p style="text-indent: 60px;font-size: 16px;line-height: 30px;">Edge浏览器下载地址：<a href="https://www.microsoft.com/zh-cn/edge" target="_blank">www.microsoft.com/zh-cn/edge</a></p>
			<p style="text-align: right;font-size: 16px;line-height: 30px;margin-top: 30px;">上海隧道工程有限公司</p>
			<p style="text-align: right;font-size: 16px;line-height: 30px;">教育培训中心</p>
			<p style="text-align: right;font-size: 16px;line-height: 30px;">标准与信息化小组</p>
			<p style="text-align: right;font-size: 16px;line-height: 30px;">2020年6月28日</p>
		</div>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import '../../assets/js/formatTime'
export default {
    data() {
        return {
			isShowContent:true,  // IE浏览器显示对应通知内容
            light: 2,  // 是否被选中
            totalPage: 0,  // 总页数
            page:1,  // 页数
            pagesize:9,  // 多少条数据
            courseList:[],  // 列表
            keyWords:[],  // 关键词
            navList:[],  // 分类列表
            active:0,  // 分类背景
            allActive:true,  // 控制全部or分类背景
            flId:undefined,  // 分类id
            videoNum:0,  // 视频总数
            isShowMore:true  // 是否显示更多
        }
    },
    mounted(){
		let getEx = this.getExplorer();
		if(getEx == 'ie'){
			this.isShowContent = false;
			return;
		}
		
        // 课程视频分类列表
        this.getClassifyList();

        // 获取课程列表 !!**20240624点击播放视频也需记录分页和分类
        // let type = this.$route.query.type;
        // if(type != undefined) {
		// 获取相关参数
		let listParams_str = sessionStorage.getItem('indexListParams')
		if(listParams_str) {
			let listParams = JSON.parse(listParams_str);
			this.light = listParams.sortNum;
			this.flId = listParams.flIdNum ? JSON.parse(listParams.flIdNum) : undefined;
			// 当移动端点击查看更多后 进入详情，返回时让page为1，以避免当page大于1时，前几页的数据看不到
			if(sessionStorage.getItem('lookMore') == '1'){
				this.page = 1;
				sessionStorage.removeItem('lookMore');
			}else{
				this.page = listParams.pageNum;
			}
			// 分类id为number，给对应分类设背景
			if(typeof(this.flId) == "number"){
				this.allActive = false;
				this.active = listParams.activeFl;
			}
			sessionStorage.removeItem('indexListParams')
		}
        // }
		this.getData();
    },
    methods: {
		// 判断是否为IE内核
		getExplorer(){
			var explorer = window.navigator.userAgent,
			    compare = function (s) { return (explorer.indexOf(s) >= 0); },
			    ie11 = (function () { return ("ActiveXObject" in window) })();
			if (compare("MSIE") || ie11) { return 'ie'; }
			else if (compare("Firefox") && !ie11) { return 'Firefox'; }
			else if (compare("Chrome") && !ie11) {
			    if (explorer.indexOf("Edge") > -1) {
			        return 'Edge';
			    } else {
			       return 'Chrome';
			    }
			}
			else if (compare("Opera") && !ie11) { return 'Opera'; }
			else if (compare("Safari") && !ie11) { return 'Safari'; }
		},
		// 获取分类列表
		getClassifyList(){
			// 获取unix时间戳到秒
			let timestamp = Date.parse(new Date())/1000;
			let data = {
			    "TimeStamp":timestamp,
			    "ID":0
			}
			this.$axios.post(Const_Api_Root+'api/Course/QueryItems',data,{
				contentType: 'application/json',
			    dateType:'JSON',
			    xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
			}).then((res)=>{
			    // 错误提示
			    if(res.data.Status == 0){
			        this.navList = res.data.Data[0].Childs;
			    }else if(res.data.Status != -2){
			        this.$message({
			            message: res.data.Data,
			            type: 'error',
			            duration: 3000
			        });
			    }
			}).catch((err)=>{
			    throw err;
			});
		},
        // 获取列表数据
        getData(type){
            this.videoNum = 0;
			let timestamp = Date.parse(new Date())/1000;
			let data = {
			    "TimeStamp":timestamp,
			    "Sort": this.light,
			    "Query": [{"Item":"Kind","Value":this.flId}],
			    "PageSize":this.pagesize,
			    "CurPage":this.page
			}
            this.$axios.post(Const_Api_Root+'api/Course/List',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				},
            }).then((res)=>{
                // console.log(res)
                // 错误提示
                if(res.data.Status == 0){
                    // 获取总列表数
                    this.totalPage = res.data.Data.Total;
                    this.videoNum = res.data.Data.VideoNum;
    
                    if(type == 'more'){
                        // 移动端的操作
                        this.courseList = this.courseList.concat(res.data.Data.Rows);
                    }else{
                        // 获取列表
                        this.courseList = res.data.Data.Rows;
                    }

                    // 隐藏移动端显示更多
                    if(this.totalPage != this.courseList.length){
                        this.isShowMore = true;
                    }else{
                        this.isShowMore = false;
                    }
                    // 格式化关键词
                    for(let i=0;i<this.courseList.length;i++){
                        let keyWord = this.courseList[i].Keywords;
                        if(keyWord != undefined){
                            this.courseList[i].Keywords = keyWord.toString();
                        }
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 分类
        getDataFn(type,id,index){
            this.page = 1;
            this.light = 2;
            this.flId = id ? id : undefined;
            // 全部
            if(type == 'all'){
                this.allActive = true;
            }else if(type == 'part'){
                // 分类
                this.active = 0
                this.allActive = false;
                this.active = this.active+index;
            }
            this.getData();
        },
        // 按名称-热门排序
        changeSort(n){
            this.page = 1;
            this.light = n;
            this.getData();
        },
        // 分页器
        currentPage(index){
            this.page = index;
            this.getData();
        },
        // 移动端的获取更多
        getMore(){
            this.page++;
            this.getData('more');
            sessionStorage.setItem('lookMore','1');
        },
        // 保存id
        saveID(id){
            sessionStorage.setItem('courseID',id);
            let parameter = {
                'pageNum':this.page,
                'sortNum':this.light,
                'flIdNum':this.flId,
                'activeFl':this.active
            }
            sessionStorage.setItem("indexListParams",JSON.stringify(parameter));
        }
    },
    filters: {
        // 格式化时间
        formatData:(value) => {
            value = new Date(value).Format("yyyy-MM-dd")
            return value;
        }
    },
    components: {
        Pagination
    }
}
</script>

<style scoped lang="less">
.ieContWrap{
	a:hover{
		text-decoration: underline;
		color: #0061FE;
	}
}
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .top{
        display: none;
    }
    .mindCont{
        width: 100%;
        padding-left: 17px;
        .classify_nav{
            width: 100%;
            overflow: hidden;
            overflow-x: scroll;
            white-space:nowrap;
            font-size: 0;
            margin: 20px 0 35px;
            display: flex;
            p{
                font-size: 14px;
                color: #19191a;
                padding: 10px 20px;
                font-weight: bold;
                box-sizing: border-box;
            }
            .router-link-active{
                background: #0061FE;
                border-radius: 18px;
                color: #fff;
            }
        }
    }
    .classifyList{
        .page{
            display: none;
        }
        .topTitle{
            margin: 0 0 30px;
            padding: 0 17px;
            h5{
                font-size: 12px;
            }
            span{
                font-size: 12px;
                margin-left: 20px;
            }
        }
        .listWrap{
            justify-content: center;
            padding: 0 17px;
            li{
                width: 100%;
                margin-bottom: 40px;
            }
        }
    }
    .moreCourse{
        font-size: 14px;
        color: #0061FE;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
    }
    // 输入框
    // .inputBox{
    //     width: 100%;
    // }
}
@media screen and (min-width: 1445px) {
    .moreCourse{
        display: none;
    }
    .mindCont{
        width: 1200px;
        margin: 0 auto;
    }
    .home{
        .classify_nav{
            width: 100%;
            height: 84px;
            font-size: 0;
            display: flex;
            align-items: center;
            p{
                color: #19191A;
                font-size: 15px;
                padding: 10px 15px;
                cursor: pointer;
            }
            .router-link-active{
                background: #0061FE;
                border-radius: 18px;
                color: #fff;
            }
        }
    }
    .listWrap{
        width: 1200px;
        margin: 0 auto;
    }
    .classifyList{
        width: 100%;
        .topTitle{
            width: 1200px;
            margin: 29px auto 27px;
            h5{
                font-size: 20px;
            }
            span{
                font-size: 16px;
                margin-left: 30px;
            }
        }
        .page{
            margin: 15px 0 40px;
        }
        li{
            margin: 30px 30px 30px 0;
            width: 31.5%;
            &:nth-child(3n){
                margin-right: 0;
            }
        }
    }
    // 输入框
    // .inputBox{
    //     width: 1200px;
    //     margin: 0 auto;
    // }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .moreCourse{
        display: none;
    }
    .mindCont{
        width: 1100px;
        margin: 0 auto;
    }
    .home{
        .classify_nav{
            width: 100%;
            height: 84px;
            font-size: 0;
            display: flex;
            align-items: center;
            p{
                color: #19191A;
                font-size: 15px;
                padding: 10px 12px;
                cursor: pointer;
            }
            .router-link-active{
                background: #0061FE;
                border-radius: 18px;
                color: #fff;
            }
        }
    }
    .listWrap{
        width: 1100px;
        margin: 0 auto;
    }
    .classifyList{
        width: 100%;
        .topTitle{
            margin: 29px auto 27px;
            width: 1100px;
            h5{
                font-size: 20px;
            }
            span{
                font-size: 16px;
                margin-left: 30px;
            }
        }
        .page{
            margin: 15px 0 40px;
        }
        li{
            margin: 30px 30px 30px 0;
            width: 31.5%;
            &:nth-child(3n){
                margin-right: 0;
            }
        }
    }
    // 输入框
    // .inputBox{
    //     width: 1100px;
    //     margin: 0 auto;
    // }
}
// 公用
.top{
    background: url('../../assets/img/index_bg.png') no-repeat;
    background-size: 100% 100%;
    height: 120px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h2{
        font-size: 34px;
        color: #FFFFFF;
        margin: 0 0 5px;
    }
}
.classifyList{
    .topTitle{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left-t{
            display: flex;
            align-items: center;
            p{
                margin-left: 30px;
            }
        }
        span{
            color: rgba(25,25,26,0.40);
            cursor: pointer;
        }
        .light{
            color: #19191A;
        }
    }
}
.listWrap{
    display: flex;
    flex-wrap: wrap;
	min-height: 500px;
    li{
        .picBox{
            width: 100%;
            height: 250px;
            position: relative;
            img{
                height: 250px;
                width: 100%;
                max-width: 100%;
                border-radius: 16px;
            }
            p{
                background: #0061FE;
                border-radius: 16px 0 16px 0;
                color: #fff;
                width: 63px;
                height: 60px;

                position: absolute;
                right: 0;
                bottom: 0;
                span{
                    display: block;
                    text-align: center;
                }
                span:first-child{
                    font-size: 24px;
                    margin-top: 4px;
                }
                span:last-child{
                    font-size: 12px;
                }
            }
        }
    }
    .infoWrap{
        width: 100%;
        max-width: 100%;
        padding-left: 15px;
        h2{
            font-size: 20px;
            color: #19191A;
            font-weight: bold;
            overflow: hidden; 
            text-overflow: ellipsis;
            white-space: nowrap; 
        }
        .info{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            display: flex;
            margin: 10px 0 20px;
            p{
                margin-right: 10px;
            }
        }
    }
    .head-zan{
        display: flex;
        align-items: center;
        padding-left: 15px;
        img{
            width: 24px;
            height: 24px;
        }
        .head{
            font-size: 14px;
            color: rgba(25,25,26,0.80);
            img{
                border-radius: 50%;
                margin-right: 10px;
                vertical-align: middle;
            }
        }
		.department{
			font-size: 13px;
			color: rgba(25,25,26,0.80);
			margin-left: 30px;
			img{
				margin-right: 10px;
				vertical-align: middle;
			}
		}
        .zan{
            display: flex;
            align-items: center;
            font-size: 12px;
            color: rgba(25,25,26,0.80);
            p{
                width: 24px;
                height: 24px;
                margin: 0 10px 0 30px;
            }
        }
    }
    .category{
        font-size: 12px;
        color: #0061FE;
        margin: 30px 0 20px;
        span{
            margin-right: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Index.vue